import { render } from "./ToolTip.vue?vue&type=template&id=4497017f&scoped=true"
import script from "./ToolTip.vue?vue&type=script&lang=js"
export * from "./ToolTip.vue?vue&type=script&lang=js"

import "./ToolTip.vue?vue&type=style&index=0&id=4497017f&scoped=true&lang=scss"

import exportComponent from "/Users/kakkote/Mediadeski/2022-01-aluevaalit-kompassianalyysi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4497017f"]])

export default __exports__